export const MULTI_FILE_DROPZONE_DEFAULT_TITLE = 'Drag & drop files here';

export const MULTI_FILE_DROPZONE_DEFAULT_BROWSE_LABEL = 'Browse files';
